module.exports = __webpack_public_path__ + "static/media/yourspace-min.e26ea6db.webp";